import {connect} from '@modifi/redux'
import {withTranslation} from '@modifi/plugin-i18n'
import {compose} from 'ramda'
import {
  aLinkDocumentRefToTransaction,
  aLinkDocumentToTransactionCleanup,
  selectIsLinkDocumentsFromTransactionError,
  selectIsLinkDocumentsFromTransactionInProgress,
  selectLinkDocumentsFromTransactionErrors,
} from '../../../../modules/link-document'

import {
  aUnlinkDocumentFromTransaction,
  aUnlinkDocumentToTransactionCleanup,
  selectIsUnlinkDocumentsFromTransactionError,
  selectIsUnlinkDocumentsFromTransactionInProgress,
  selectUnlinkDocumentsFromTransactionErrorMessage,
} from '../../../../modules/unlink-document'

import ManageDocuments from './ManageDocument'

const mapStateToProps = state => ({
  inProgress:
    selectIsLinkDocumentsFromTransactionInProgress(state) ||
    selectIsUnlinkDocumentsFromTransactionInProgress(state),
  hasError:
    selectIsLinkDocumentsFromTransactionError(state) ||
    selectIsUnlinkDocumentsFromTransactionError(state),
  errorMessages: [
    ...selectLinkDocumentsFromTransactionErrors(state).map(({errorMessage}) => errorMessage),
    selectUnlinkDocumentsFromTransactionErrorMessage(state),
  ].filter(Boolean),
})

const mapDispatchToProps = {
  linkDocumentToPayment: aLinkDocumentRefToTransaction,
  unlinkDocumentFromPayment: aUnlinkDocumentFromTransaction,
  dialogCleanup: () => dispatch => {
    dispatch(aLinkDocumentToTransactionCleanup())
    dispatch(aUnlinkDocumentToTransactionCleanup())
  },
}

export const DIALOG_NAME = 'transaction/manage-documents'

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation('moneta')
)(ManageDocuments)
